import {Button, Grid, Typography} from '@yandex-delivery/blocks'
import type {
  TimelineBubbleAction,
  TimelineBubble as TimelineBubbleType,
} from '@yandex-delivery/types/schemas/services/cargo-c2c/definitions/timeline'
import clsx from 'clsx'
import React, {useCallback, useState} from 'react'
import {tagToUrl} from 'src/shared/utils'

import {TimelineDetailsModal} from './TimelineDetailsModal'
import {classes} from './Validator.classes'

type Props = {
  bubble: TimelineBubbleType
  pointCount: number
  currentPointIndex: number
}

export const Validator: React.FC<Props> = ({bubble, pointCount, currentPointIndex}) => {
  const [modalAction, setModalAction] = useState<TimelineBubbleAction | null>(null)

  const handleButtonClick = useCallback(() => {
    if (bubble.button) {
      // Сохраняем snapshot action и открываем модал
      // Защита от race condition: если polling обновит данные после клика,
      // модал всё равно откроется с данными на момент клика
      setModalAction(bubble.button.action)
    }
  }, [bubble.button])

  const handleCloseModal = useCallback(() => {
    setModalAction(null)
  }, [])

  return (
    <>
      <div className={classes.container}>
        {pointCount > 0 && (
          <Grid className={classes.tailContainer} container justify="center">
            {[...Array(pointCount)].map((_, index) => (
              <div className={clsx(classes.tail, currentPointIndex === index && classes.tailVisible)} key={index} />
            ))}
          </Grid>
        )}

        <div className={classes.bubble}>
          <Grid alignItems="center" container spacing={2} wrap="nowrap">
            {bubble.lead_icon_tag && (
              <Grid item>
                <img
                  alt=""
                  className={classes.icon}
                  data-theme-invert
                  loading="lazy"
                  src={tagToUrl(bubble.lead_icon_tag)}
                />
              </Grid>
            )}

            <Grid item xs>
              <Typography className={classes.title} variant="caption1">
                {bubble.title}
              </Typography>
            </Grid>

            {bubble.button && (
              <Grid item>
                <Button className={classes.button} onPress={handleButtonClick} size="xs" variant="ghost">
                  <Typography Component="span" className={classes.buttonText} thickness="medium" variant="caption1">
                    {bubble.button.title}
                  </Typography>
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </div>

      {/* Модал с деталями таймлайна */}
      {modalAction && <TimelineDetailsModal action={modalAction} onClose={handleCloseModal} />}
    </>
  )
}
